export default __webpack_public_path__ + "static/media/linkedin.b874e562.png";